<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Bypass Review &amp; Rating for {{ data_user.name }}</h1>
    </div>
    <div class="">
      <div class="form-group col-12">
        <label for="#form-subject" class="pl-0 m-0 d-flex align-items-center">Rating</label>
        <div>
          <star-rating v-model="rating" :increment="0.1"/>
        </div>
      </div>
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-subject" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Review</label>
          <textarea class="form-control" id="form-subject" v-model="review"></textarea>
        </div>
      </div>
      <div class="form-group col-12 text-right">
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#preloader_modal" @click="save">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import 'summernote/dist/summernote.css'
import summernote from 'summernote'
import StarRating from 'vue-star-rating'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
    StarRating,
  },
  data(){
    return{
      rating: 0,
      review: '',
      data_user: {},
      data: {},
    }
  },
  mounted(){
    this.get_user_data()
    if(this.$route.query.id != null)
      this.get_data()
  },
  methods:{
    async get_user_data(){
      var response = await axios.get(base_url+'/user?id='+this.$route.query.user_id)

      var response_data = response.data

      if(response_data.status == "success"){
        this.data_user = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_data(){
      var response = await axios.get(base_url+'/rating?id='+this.$route.query.id)

      var response_data = response.data

      if(response_data.status == "success"){
        this.data = response_data.data
        this.rating = this.data.rating
        this.review = this.data.review
      }
      else
        this.$toasted.show(response_data.message)
    },
    async save(){
      try{
        if(this.rating == '')
          this.$toasted.show('Rating is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          data.rating = this.rating
          data.review = this.review
          if(this.$route.query.id != null)
            data.id = this.$route.query.id
          data.invoice_call = {
            id: this.$route.query.id == null ? this.$route.query.invoice_call_id : this.data.invoice_call_id
          }
          data.user = {
            id: this.$route.query.id == null ? this.$route.query.user_id : this.data.user_id
          }
          data.recipient = {
            id: this.$route.query.id == null ? this.$route.query.recipient_id : this.data.recipient_id
          }

          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/rating',data)
          else
            var response = await axios.put(base_url+'/rating',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = "/order-call/detail?id=" + this.$route.query.invoice_call_id
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    }
  }
}
</script>
